























import {
    Component,
    Prop,
    Vue,
    Emit,
Watch,
} from 'vue-property-decorator';
import * as _ from 'lodash';

@Component({})
export default class ReuseTab extends Vue {

    @Prop({
        type: Array,
        default() {
            return [];
        },
    })
    private list!: any[];

    @Prop({
        type: String,
        default: '',
    })
    private pos!: string;

    @Emit('changePath')
    private to(event: any, index: any) {

    }

    private close(event: any, index: any, close: boolean) {
        if  (this.list.length === 1 ) {
            // console.log('只有一个路由标签，不能删除');
            this.$message.error('只有一个路由标签，不能删除');
            return;
        }
        this.onCloseTab(event, index, close);
    }

    @Emit('closeTab')
    private onCloseTab(event: any, index: any, close: boolean) {

    }

}
